export const env = {
  amplitudeId: '1cff4492ddcd7defb9e6e17fa4084dce',
  hotJarId: '3644358',
  tawkToProjectId: '64fdb210b2d3e13950eefb9f',
  tawkToChatId: '1h9vfv4a2',
  apiDomain: '',
  sendSmallIncomeHookUrl: 'https://hook.eu1.make.com/94bg6doluapte6uu1rnu9u3qoznt83mk',
};
